import { useModal } from "../contexts";
import Modal from "./Modal";
import { useTranslation } from "react-i18next";

interface Props {
  onConfirm: () => Promise<void>;
}

function ChangeRecipientModal(props: Props) {
  const { closeModal } = useModal();
  const { t } = useTranslation();

  async function handleConfirm() {
    await props.onConfirm();
    closeModal();
  }

  return (
    <Modal
      title={t("Change Recipient")}
      subtitle={t("Update the email address for this recipient.")}
      secondaryButtonProps={{ text: t("Cancel"), onClick: closeModal }}
      primaryButtonProps={{
        text: t("Confirm"),
        onClick: handleConfirm,
      }}
      size="sm"
    >
      <div>{t("This action will invalidate the currently requested signature request and put the remaining signature requests into a draft state to be updated.")}</div>

    </Modal>
  );
}

export default ChangeRecipientModal;
